import mongoose from 'mongoose'
import { setBaseSchema } from './Schema'
import { t } from 'react-switch-lang'

const Schema = mongoose.Schema

var DisplaySchema = new Schema({
    id: { type: String, required: false, default: null },
    mac: { type: String, required: [true, 'validate.require'] },
    // model: { type: String, required: false, default: null },
    // ipAddress: { type: String, required: false, default: null },
    room: { type: Object, required: false, default: null },
    status: { type: String, required: false, default: null },
})

setBaseSchema(DisplaySchema, "03")

DisplaySchema.methods.serializeAPI = function () {
    try {
        let result = {
            mac: this.mac,
            room: this.room,
            status: this.status,
        }

        return result
    } catch (error) {
        return null
    }
}

DisplaySchema.methods.setData = function (data) {
    try {
        this.id = data.id
        this.mac = data.mac
        this.room = data.room
        this.status = data.status
    } catch (error) {

    }
}

/************************************************************************
 * 
 * Validator Method
 * 
 *************************************************************************/
const DisplayModel = mongoose.model("display", DisplaySchema, "display")

export default DisplayModel



// WEBPACK FOOTER //
// ./src/app/model/displayModel.js